import angular from 'angular';

/**
 * @ngdoc filter
 * @name app.filter:shuffle
 * @function
 * @description
 * # shuffle
 * Filter in the app.
 */
angular.module('app')
	.filter('shuffle', /* @ngInject */ Utils => Utils.shuffle);
